<script>
    import Icon from 'views/components/icon/Icon.svelte'
</script>

<span class="exemption-label" component="exemption-label">
    <Icon name="palm-tree"></Icon>
    <span>{window.i18n.gettext('Exemption')}</span>
</span>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.exemption-label {
  font-size: 14px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  background-color: rgb(222.14475, 234.094025, 223.52525);
  color: #21894d;
  border-radius: 12px;
}
.exemption-label :global(svg) {
  width: 16px;
  height: 16px;
  fill: currentColor;
}</style>
